import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ChannelUserFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/ChannelUser';
export type CommunityChannelFragment = { id: string, name: string, icon?: string | null, description?: string | null, allowedToPost?: Types.ChannelAllowedToPostEnum | null, accessType: Types.ChannelAccessTypeEnum, status: Types.ChannelStatusEnum, topic: string, userPermissions: Array<{ action: Types.ChannelActionsEnum, subject: Types.ChannelSubjectsEnum }>, visibilitySettings?: { accessType: Types.VisibilitySettingsAccessTypeEnum, groupIds?: Array<string> | null } | null, channelUser?: { id: string, lastViewedAt: string, unreadCount?: number | null } | null };


export type CommunityChannelFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const CommunityChannelFragmentDoc = /*#__PURE__*/ gql`
    fragment CommunityChannel on ChannelType {
  id
  name
  icon
  description
  allowedToPost
  accessType
  userPermissions {
    action
    subject
  }
  visibilitySettings {
    accessType
    groupIds
  }
  channelUser {
    ...ChannelUser
  }
  status
  topic
}
    `;